"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { ChevronDown } from "lucide-react"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { useLanguage } from "@/contexts/language-context"

export function LanguageSelector() {
  const { currentLanguage, setLanguage } = useLanguage()

  const languages = [
    { code: "en", name: "English", nativeName: "English" },
    { code: "zh-cn", name: "简体中文", nativeName: "简体中文" },
    { code: "zh-tw", name: "繁體中文", nativeName: "繁體中文" },
    { code: "es", name: "Español", nativeName: "Español" },
    { code: "fr", name: "Français", nativeName: "Français" },
    { code: "de", name: "Deutsch", nativeName: "Deutsch" },
    { code: "ja", name: "日本語", nativeName: "日本語" },
    { code: "ko", name: "한국어", nativeName: "한국어" },
    { code: "pt", name: "Português", nativeName: "Português" },
    { code: "ru", name: "Русский", nativeName: "Русский" },
    { code: "ar", name: "العربية", nativeName: "العربية" },
    { code: "hi", name: "हिन्दी", nativeName: "हिन्दी" },
    { code: "it", name: "Italiano", nativeName: "Italiano" },
    { code: "nl", name: "Nederlands", nativeName: "Nederlands" },
    { code: "sv", name: "Svenska", nativeName: "Svenska" },
    { code: "pl", name: "Polski", nativeName: "Polski" },
    { code: "tr", name: "Türkçe", nativeName: "Türkçe" },
    { code: "th", name: "ไทย", nativeName: "ไทย" },
    { code: "vi", name: "Tiếng Việt", nativeName: "Tiếng Việt" },
    { code: "id", name: "Bahasa Indonesia", nativeName: "Bahasa Indonesia" },
  ]

  const getCurrentLanguageDisplay = () => {
    const lang = languages.find(l => l.code === currentLanguage)
    return lang ? lang.code.toUpperCase() : "EN"
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="gap-1 hover:bg-slate-100 dark:hover:bg-zinc-700 dark:text-gray-300 dark:hover:text-white transition-colors"
        >
          {getCurrentLanguageDisplay()}
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-y-auto">
        {languages.map((lang) => (
          <DropdownMenuItem key={lang.code} onClick={() => setLanguage(lang.code)}>
            <span className="font-medium">{lang.nativeName}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
